import React from 'react'
import { useNavigate } from 'react-router-dom';


const Home = () => {
    const navigate = useNavigate();
    const [yesWords] = React.useState([
        "Yes please",
        "Sure",
        "I'd love to",
        "I'm in",
        "Why not?",
        "Absolutely",
        "Of course",
        "Definitely",
        "You no go gree ke",
        "I'm down",
        "I'm game",
        "Count me in",
        "I'm all in",
        "I'm ready",
        "I'm excited",
        "I'm thrilled",
        "I'm stoked",
        "I'm pumped",
        "I'm hyped",
        "I'm ecstatic",
        "You don't have to ask me twice",
        "I'm all yours",
        
    ]);

    const [noWords] = React.useState([
        "No thanks",
        "I'm good",
        "I'll pass",
        "Not today",
        "I'm busy",
        "I'm not interested",
        "I'm not available",
        "I'm not looking for anything",
    ]);


    const [size, setSize] = React.useState({
        yesSize: 1,
        noSize: 1,
    });

    const [active, setActive] = React.useState(yesWords[Math.floor(Math.random() * yesWords.length)]);
    const [inactive, setInactive] = React.useState(noWords[Math.floor(Math.random() * noWords.length)]);

    

    const sayYes = () => {
        navigate('/yes');
    }
    const sayNo = () => {
        setActive(yesWords[Math.floor(Math.random() * yesWords.length)]);
        setInactive(noWords[Math.floor(Math.random() * noWords.length)]);

        //make yes size bigger and no size smaller
        setSize({
            yesSize: size.yesSize * 1.15,
            noSize: size.noSize / 1.005,
        });
    }
    return (
        <main>
            <div className="relative isolate px-6 lg:px-8">
                <div
                    className="absolute inset-x-0 -z-40 transform-gpu overflow-hidden blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div className="mx-auto max-w-5xl py-20 sm:py-28 lg:py-32">
                    <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                        <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                            Valentine: {" "}
                            <span className="font-semibold text-red-600">
                                <span className="absolute inset-0" aria-hidden="true" />
                                love, passion, and romance
                            </span>
                        </div>
                    </div>
                    <div className="text-center">
                        <h1 className="text-4xl font-bold tracking-tight text-gray-700 sm:text-6xl lg:text-7xl">
                            <span className='text-gradient bg-clip-text text-transparent bg-gradient-to-r to-pink-400 from-red-600'>
                                It's Valentine's Day
                            </span>
                        </h1>
                        <p className="mt-6 text-gray-600 font-medium">
                            I'm giving you the special chance to be my val, no questions asked, who says no?
                        </p>
                        <div className="mt-10 lg:mt-16 flex items-center justify-evenly gap-x-6">
                            <div
                                onClick={sayYes}
                                style={{ transform: `scale(${size.yesSize})` }}
                                className={`scale-${size.yesSize*100} cursor-pointer rounded-md bg-gradient-to-r to-pink-400 from-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600`}
                            >
                               {active}
                            </div>
                            <div
                                style={{ transform: `scale(${size.noSize})` }}
                                onClick={sayNo}
                                className={`scale-${size.noSize * 100} cursor-pointer text-sm font-semibold leading-6 text-indigo-900`}>
                                {inactive}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    aria-hidden="true"
                >
                    <div
                        className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
            </div>
        </main>
    )
}

export default Home